import type { QuestionnaireItem } from "@ferrivia/api-contract";
import { isAnswered, itemsFor, type AnswerMap, type ItemFields } from "./answerMap";
import { INFUSION, SECTIONS, SUPPLEMENT_GROUPS, sectionHasContent, type Section, type SupplementGroup } from "./summaryLayout";

export function gateValue(answers: AnswerMap, key: string): boolean | null {
  const value = answers[key];
  return value?.kind === "boolean" ? value.value : null;
}

export function groupHasContent(group: SupplementGroup, answers: AnswerMap, items: readonly QuestionnaireItem[]): boolean {
  const gate = gateValue(answers, group.gate);
  return gate === false || (gate === true && itemsFor(items, group.groupKey).length > 0);
}

export function infusionHasContent(answers: AnswerMap, items: readonly QuestionnaireItem[]): boolean {
  const gate = gateValue(answers, INFUSION.gate);
  return (
    gate === false ||
    (gate === true && (isAnswered(answers[INFUSION.details]) || itemsFor(items, INFUSION.groupKey).length > 0))
  );
}

export function supplementsHaveContent(answers: AnswerMap, items: readonly QuestionnaireItem[]): boolean {
  return SUPPLEMENT_GROUPS.some((group) => groupHasContent(group, answers, items)) || infusionHasContent(answers, items);
}

export function visibleSections(answers: AnswerMap): Section[] {
  return SECTIONS.filter((section) => sectionHasContent(section, answers));
}

// Newest first by infusion_date; undated rows keep their item order, last.
export function infusionsNewestFirst(rows: ItemFields[]): ItemFields[] {
  const dateOf = (item: ItemFields) => (item.infusion_date?.kind === "date" ? item.infusion_date.value : null);
  return rows
    .map((item, index) => ({ item, index, date: dateOf(item) }))
    .sort((a, b) => {
      if (a.date && b.date) {
        return a.date === b.date ? a.index - b.index : a.date < b.date ? 1 : -1;
      }
      if (a.date || b.date) {
        return a.date ? -1 : 1;
      }
      return a.index - b.index;
    })
    .map(({ item }) => item);
}
